.root {
  display: flex;
  gap: 0.25rem;
  align-items: center;
  color: var(--link);

  svg {
    width: 1rem;
    height: 1rem;
  }
}

.input {
  min-width: auto;
  color: var(--link);
  outline: none;
  background: transparent;
  border: none;
  transform: translateY(1px);

  &::placeholder {
    color: inherit;
    opacity: 1;
  }

  &:active {
    color: var(--link-active);
  }
}
